import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { AppLanguage } from '../../constants';
import { AppStrings } from '../localizations';
import { LangContext } from '../../contexts/lang.context';

interface Props {
  RouterComponent: React.ComponentClass<any>;
  appStrings: { [prop: string]: AppStrings };
}

export const LocalizedRouter: React.FC<Props> = ({ children, RouterComponent, appStrings }) => (
  <RouterComponent>
    <Route path="/:lang([a-z]{2})">
      {({ match, location }) => {
        const appLanguages: string[] = Object.values(AppLanguage);
        let lang: string;

        if (match !== null) {
          const paramsLang: string = match.params.lang;

          if (!appLanguages.includes(paramsLang)) {
            return <Redirect to={`/`} />;
          }

          lang = paramsLang;
        } else {
          const localStorageLang: string | null = localStorage.getItem('lang');

          if (localStorageLang !== null && appLanguages.includes(localStorageLang)) {
            lang = localStorageLang;
          } else {
            const windowLanguage: string = window.navigator.language.substring(0, 2);

            lang = appLanguages.includes(windowLanguage) ? windowLanguage : AppLanguage.English;
          }
        }

        localStorage.setItem('lang', lang);

        // If language is not in route path, redirect to language root
        const { pathname } = location;
        if (!pathname.includes(`/${lang}/`)) {
          return <Redirect to={`/${lang}/`} />;
        }

        // Return Intl provider with default language set
        return (
          <LangContext.Provider value={{ lang, currentLangData: appStrings[lang] }}>
            {children}
          </LangContext.Provider>
        );
      }}
    </Route>
  </RouterComponent>
);
